import { useEffect, useMemo, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { bs, useBoundStore } from '../../../state/bound.store'
import { getRocketChatUrl } from '../../../utils'
import { isConnectivityAvailable } from '../../connectivity/connectivityListener'
import { getChatCache } from '../chatStore'
import { ChatBodyPage } from './chatBodyPage'
import { ChatBodyProvider } from './chatProvider'

export const ChatBodyWrapper = () => {
    const { selectedOrg, rcTokens } = useBoundStore(
        useShallow((s) => {
            return { selectedOrg: s.selectedOrg, rcTokens: s.rcTokens }
        })
    )
    const orgToken = useMemo(() => {
        if (rcTokens && selectedOrg) {
            const token = rcTokens.find((t) => t?.org === selectedOrg.name)
            return token
        }
        return null
    }, [rcTokens, selectedOrg])

    const [cachedUserId, setCachedUserId] = useState<string>('')

    useEffect(() => {
        async function getUserIdFromCache() {
            setCachedUserId(
                (await getChatCache<string>(
                    'me',
                    'userId-' + (selectedOrg?.name ?? ' ')
                )) ?? ''
            )
        }
        getUserIdFromCache()
    }, [selectedOrg])

    return !orgToken || !isConnectivityAvailable.value ? (
        <ChatBodyProvider
            host={getRocketChatUrl(bs().selectedOrg?.name ?? '')}
            userId={cachedUserId}
            authToken={orgToken?.authToken}
        >
            <ChatBodyPage />
        </ChatBodyProvider>
    ) : (
        <ChatBodyProvider
            host={getRocketChatUrl(orgToken.org)}
            userId={orgToken.userId}
            authToken={orgToken?.authToken}
        >
            <ChatBodyPage />
        </ChatBodyProvider>
    )
}
